import api from '../api/api';

// reducers
import notificationCenterDictionariesReducer from './dictionaries/slices';
import notificationCenterReducer from '../hoc/center/store/slices';

export const notificationCenterReducers = {
  notificationCenterApi: api.reducer,
  notificaticationCenterDictionaries: notificationCenterDictionariesReducer,
  notificationCenter: notificationCenterReducer,
};

export const notificationCenterApi = api;
